import React from "react";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import GlobalCta from "../../components/global/GlobalCta";
import PageHero from "../../components/global/PageHero";
import ServiceOverview from "../../components/global/ServiceOverview";
import ServiceFeatures from "../../components/global/ServiceFeatures";
import ServiceChecks from "../../components/global/ServiceChecks";

const OVERVIEW = [
    "Our infrastructure team brings years of hands-on server and network expertise across cloud, on-premise and hybrid environments. Whatever the challenge, we bring the depth to solve it properly.",
    "From architecture and security to performance and troubleshooting, we advise and implement so your infrastructure is built right and runs well.",
];

const FEATURES = [
    { title: "Architecture & design", text: "Infrastructure planned to be secure, resilient and ready to scale." },
    { title: "Security expertise", text: "Hardening and best practice applied across servers and networks." },
    { title: "Performance optimisation", text: "Tuning that keeps systems fast and efficient under load." },
    { title: "Troubleshooting", text: "Deep diagnostic skill to resolve the issues others get stuck on." },
];

const CHECKS = [
    "Infrastructure architecture",
    "Security & hardening",
    "Performance optimisation",
    "Cloud, on-premise & hybrid",
    "Advisory & implementation",
];

export default function Expertise() {
    return (
        <>
            <Header />

            <main>
                <PageHero eyebrow="Server & Networking" title="Server & Network Expertise" eyebrowAs="span">
                    Deep, hands-on infrastructure knowledge — the expertise to design, secure and optimise the systems your business depends on.
                </PageHero>
                <ServiceOverview paragraphs={OVERVIEW} />
                <ServiceFeatures items={FEATURES} />
                <ServiceChecks title="What's included" items={CHECKS} />
            </main>

            <GlobalCta />

            <Footer />
        </>
    );
}
